<!-- HomeScreenPrompt.vue -->
<template>
    <div v-if="showPrompt && showPromptMobileIOS === false" class="w-full z-50 bottom-0 fixed
        text-center p-3 bg-[var(--color-white)] border border-[#ccc]">
      <div>
        <p class="text-[var(--color-orange)]">{{ $t('HomeScreenPrompt.text') }}</p>
        <button class="block mx-auto py-3 px-9 border-none rounded-full text-xl
            text-[var(--color-white)] bg-[var(--color-black)]" @click="addToHomeScreen">
          {{ $t('HomeScreenPrompt.button') }}
        </button>
      </div>
      <button class="absolute top-1 right-4 bg-none border-none text-xl font-bold cursor-pointer
        m-0 p-0" @click="onDeclinePrompt">
        <font-awesome-icon icon="fa-xmark"/>
      </button>
    </div>
    <div v-if="showPromptMobileIOS" class="rounded-lg bg-white p-3 fixed bottom-10 z-50 w-full
        flex items-center justify-center gap-2">
      <div class="rounded-sm py-1 px-2 bg-[#8e8e8e]">
        <font-awesome-icon icon="fa-plus" class="text-[var(--color-white)]"/>
      </div>
      <p class="w-96 text-xs">
        {{ $t('HomeScreenPrompt.iphone.installTheWebapp') }}
        <img class="h-5 py-0 px-1" src="@/assets/share-icon-iso.png" alt="txt">
        {{ $t('HomeScreenPrompt.iphone.andThenTap') }}
      </p>
    </div>
  </template>

<script>
export default {
  data() {
    return {
      showPrompt: false,
      showPromptMobileIOS: false,
      deferredPrompt: null,
    };
  },
  computed: {
    promptCount: {
      get() {
        return Number(localStorage.getItem('promptCount')) ?? 0;
      },
      set(value) {
        localStorage.setItem('promptCount', value);
      },
    },
    consecutiveDeclines: {
      get() {
        return Number(localStorage.getItem('consecutiveDeclines')) ?? 0;
      },
      set(value) {
        localStorage.setItem('consecutiveDeclines', value);
      },
    },
  },
  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },
    isMobileIOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    },
    isNotInAppMode() {
      return !window.matchMedia('(display-mode: standalone)').matches;
    },
    addToHomeScreen() {
      if (this.deferredPrompt) {
        // Show the browser's installation prompt
        this.deferredPrompt.prompt();

        // Wait for the user's choice
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            // accepted
          } else {
            // no accepted
          }
          this.showPrompt = false;
          this.deferredPrompt = null;
        });
      }
    },
    onShowPrompt() {
      this.promptCount += 1;
      if (this.consecutiveDeclines <= 3
      && (this.promptCount % 10 === 0 || this.promptCount === 0)) this.showPrompt = true;
    },
    onDeclinePrompt() {
      this.showPrompt = false;
      this.consecutiveDeclines += 1;
    },
    onShowPromptMobileIOS() {
      this.promptCount += 1;
      if (this.consecutiveDeclines <= 3
      && (this.promptCount % 10 === 0 || this.promptCount === 0)) this.showPromptMobileIOS = true;
    },
  },
  created() {
    if (this.isNotInAppMode() && this.isMobile()) {
      // Listen for the beforeinstallprompt event
      if (this.isMobileIOS() && this.isSafari()) {
        this.onShowPromptMobileIOS();
        setTimeout(() => {
          this.showPromptMobileIOS = false;
        }, 3000);
      }
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault(); // Prevent the default browser prompt
        this.deferredPrompt = e;
        this.onShowPrompt();
      });
    }
  },
};
</script>
